import { Modal , Button } from "react-bootstrap";


const CustomModal = ({
  children,
  show,
  handleClose = () => { },
  headerText = null,
  closeButtonText = null,
  actionButtonText = null,
  actionButton = () => { }
}) => {
  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      {
        headerText && (
          <Modal.Header closeButton>
            <Modal.Title><h4 style={{fontWeight: 600}} className="m-0">{headerText}</h4></Modal.Title>
          </Modal.Header>
        )
      }
      <Modal.Body className="text-center">
        {children}
      </Modal.Body>

      {(closeButtonText || actionButtonText) && (
        <Modal.Footer>

          {
            actionButtonText && (
              <Button
                variant="primary"
                onClick={actionButton}
              >
                {actionButtonText}
              </Button>
            )
          }

          {
            closeButtonText && (
              <Button
                variant="primary"
                onClick={handleClose}
              >
                {closeButtonText}
              </Button>
            )
          }

        </Modal.Footer>
      )}
    </Modal>
  );
};

export default CustomModal;
